<template>
<!-- プロジェクト登録モーダル -->
<transition name="modal">
  <div class="modal-mask" @click="$emit('close')">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div>
          <CRow>
            <CCol>
              <table class="table">
                <thead>
                  <a style="font-size: 20px"><strong>登録内容確認</strong></a>
                  <CCardText><strong>以下の内容を登録してよろしいですか？</strong></CCardText>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <a><strong>取引先企業名</strong></a><br>
                      {{ company }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>プロジェクト名</strong></a><br>
                      {{ project }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>プロジェクト責任者</strong></a><br>
                      {{ own_staff }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>先方担当者</strong></a><br>
                      {{ staff }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>協力会社</strong></a><br>
                      {{ related }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>その他関連</strong></a><br>
                      {{ otherRelated }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>始業時刻</strong></a><br>
                      {{ start }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>終業時刻</strong></a><br>
                      {{ end }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>休憩開始時間</strong></a><br>
                      {{ restStart }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>休憩終了時間</strong></a><br>
                      {{ restEnd }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>契約形態</strong></a><br>
                      {{ contract }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>下限時間</strong></a><br>
                      {{ baseTimeMin }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>上限時間</strong></a><br>
                      {{ baseTimeMax }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>その他契約事項</strong></a><br>
                      {{ otherContract }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>必要な資格・スキル</strong></a><br>
                      {{ language }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>使用機材・ツール</strong></a><br>
                      {{ otherTech }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </CCol>
          </CRow>
          <CRow>
            <CCol>
              <button @click="$emit('close')" class="btn btn-info">キャンセル</button>
            </CCol>
            <CCol>
              <save-button
                :label="'登録'"
                :loading="loading"
                :disabled="authorized"
                class="btn btn-info"
                @click="$emit('register')"
              />
            </CCol>
          </CRow>
        </div>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
import SaveButton from '../common/SaveButton'
export default {
  name: 'ProjectRegisterModal',
  components: { SaveButton },
  data() {
    return {}
  },
  props: {
    project: String,
    start: String,
    end: String,
    restStart: String,
    restEnd: String,
    company: String,
    staff: String,
    own_staff: String,
    authorized: Boolean,
    related: String,
    contract: String,
    otherRelated: String,
    baseTimeMin: Number,
    baseTimeMax: Number,
    otherContract: String,
    language: String,
    otherTech: String,
    loading: Boolean,
  }
}
</script>

<style scoped>
td {
  word-break: break-all;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(80, 80, 80, 0.5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  max-height: calc(100vh - 100px);
  width: 40%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  overflow-y: scroll;
}
</style>
